import { render, staticRenderFns } from "./TaskPapers.vue?vue&type=template&id=3554c5d4"
import script from "./TaskPapers.vue?vue&type=script&lang=js"
export * from "./TaskPapers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports